<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1120 1000">
    <MapLayer :shop-map-ids="shopMapIds" />
    <WardNameLayer />
    <g id="chiba-clickable-group" data-name="clickable_map">
      <template v-for="item in this.mapItems">
        <polygon
          :key="item.id"
          :id="`chiba-${item.name_en}`"
          tabindex="0"
          role="radio"
          :aria-label="item.name"
          :aria-checked="isChecked(item.id)"
          :points="item.points"
          class="map-selector"
          @click="selectArea(item.id)"
        />
      </template>
    </g>
    <MarkLayer />
  </svg>
</template>

<script>
import MapLayer from './MapLayer.vue';
import MarkLayer from './MarkLayer.vue';
import WardNameLayer from './WardNameLayer.vue';

export default {
  components: {
    MapLayer,
    MarkLayer,
    WardNameLayer,
  },
  props: ['mapAreaId', 'shopMapIds'],
  data: () => ({
    selectedArea: '',
  }),
  computed: {
    mapItems() {
      return [
        {
          id: 28, // 各idプロパティは仮のものを設定しています
          name: this.$t('chuo_ku'),
          name_en: 'chuo-ku',
          points:
            '650.565 842.615 601.708 872.564 347.145 681.434 463.772 482.457 617.317 461.577 761.135 669.628 650.565 842.615',
        },
        {
          id: 29,
          name: this.$t('hanamigawa_ku'),
          name_en: 'hanamigawa-ku',
          points:
            '357.684 364.408 194.567 256.858 530.129 11.597 671.681 164.711 357.684 364.408',
        },
        {
          id: 30,
          name: this.$t('inage_ku'),
          name_en: 'inage-ku',
          points:
            '463.772 482.457 357.684 364.408 671.681 164.711 788.966 351.072 684.603 385.383 617.317 461.577 463.772 482.457',
        },
        {
          id: 31,
          name: this.$t('wakaba_ku'),
          name_en: 'wakaba-ku',
          points:
            '761.135 669.628 617.317 461.577 684.603 385.383 788.966 351.072 1024.373 489.592 1017.898 750.232 761.135 669.628',
        },
        {
          id: 32,
          name: this.$t('midori_ku'),
          name_en: 'midori-ku',
          points:
            '650.565 842.615 761.135 669.628 1017.898 750.232 1012.089 872.564 890.208 987.597 650.565 842.615',
        },
        {
          id: 33,
          name: this.$t('mihama_ku'),
          name_en: 'mihama-ku',
          points:
            '194.567 256.858 76.95 398.804 370.928 640.857 463.772 482.457 357.684 364.408 194.567 256.858',
        },
      ];
    },
  },
  mounted: function() {
    this.selectedArea = this.mapAreaId;
  },
  methods: {
    selectArea(value) {
      if (this.shopMapIds && !this.shopMapIds.includes(value)) return;
      this.selectedArea = value;
      this.$emit('input', value);
      this.$emit('changeMapArea');
    },
    isChecked(value) {
      return this.selectedArea === value;
    },
  },
};
</script>

<style scoped>
.map-selector {
  fill: transparent;
  stroke: transparent;
  stroke-linejoin: round;
  stroke-width: 8px;
}
.map-selector:focus {
  outline: none;
}
.map-selector[aria-checked='true'] {
  stroke: #B22C27;
  stroke-width: 16px;
}
</style>
